<template>
    <div>
        <v-select
            prepend-inner-icon="assignment"
            outlined
            dense
            v-on:input="$emit('input', $event)"
            item-text="name"
            item-value="name"
            :value="value"
            menu-props="auto"
            class="soli-round soli-grey"
            :items="roles"
            label="Staff Role"
            :disabled="disabled"
            :clearable="clearable"
            ><template #append-outer
                ><v-icon
                    v-if="help"
                    @click="showPermissions = true"
                    color="primary"
                    >help</v-icon
                ></template
            ></v-select
        >
        <SoliForm
            v-if="showPermissions"
            title="Staff Permissions"
            hideBtn
            noContainer
            limitScroll
            ><template #body>
                <v-container class="pt-0 px-4">
                    <v-list v-for="role in roles" :key="role.id">
                        <div>{{ role.name }}</div>
                        <div
                            v-for="permission in role.permissions"
                            :key="permission.name"
                            class="px-3"
                        >
                            <small>{{ "-" + permission.name }}</small>
                        </div>
                    </v-list></v-container
                ></template
            ></SoliForm
        >
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        disabled: { type: Boolean, default: false },
        clearable: { type: Boolean, default: false },
        help: { type: Boolean, default: false },
    },
    data: function () {
        return {
            roles: [],
            showPermissions: false,
        };
    },
    methods: {
        getRolesAndPermissions() {
            axios
                .get("/api/roles-and-permissions/", {})
                .then((resp) => {
                    this.roles = resp.data;
                    this.loading = false;
                })
                .catch((error) => {
                    this.$emit("error", error);
                });
        },
    },
    mounted() {
        this.getRolesAndPermissions();
    },
};
</script>
